let paginationOptions = [10, 25, 50, 100];

const environment = process.env.REACT_APP_ENV;
let apiUrl = process.env.REACT_APP_API_URL_LOCAL;

if (environment === "production") {
  apiUrl = process.env.REACT_APP_API_URL;
}


const config = {
  api_url: apiUrl,
  DECRYPT_KEY: "r5u8x/A?D(G+KbPeShVmYq9s2v7y$C&E",
  DECRYPT_IV: "5fgf5HJ5g2752907",
  IS_JSON: true,
  MAX_IMAGE_SIZE: 10 * 1024 * 1024, //10 MB
  MAX_VIDEO_SIZE: 100 * 1024 * 1024, //100 MB
  PAGINATION_OPTIONS: paginationOptions,
  login_data: "@secure.@data",
  dataTableLength: [10, 25, 75, 100],
  ROLE_ADMIN: 1,
  ROLE_USER: 2,
  ROLE_CUSTOMER: 3,
  ROLE_STORE_EMPLOYEE: 4,
  DATA_LIMIT:20,
  config_data: "configData",

};

export default config;
